import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import OrderTypeCarding from "./OrderTypeCarding";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthContext } from "../../context/AuthContext";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import axios from "axios";

const OrderTypeShow = (props) => {
  const updater = useSelector((state) => state.updateReducer.orderTypes);
  const [isLoading, setIsLoading] = useState(false);
  const auth = useContext(AuthContext);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [types, setTypes] = useState();
  const { enqueueSnackbar } = useSnackbar();

  const getOrderTypes = async () => {
    setIsLoading(true);
    await axios
      .post(
        "/api/v1/laboratorys/get-orderTypes",
        {
          onlyName: false,
          page: page,
          rowCount: 4,
        },
        {
          headers: {
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setTypes(response.data.data.result);
        setTotal(response.data.data.totalItem);
      })
      .catch((e) => {
        const messages = e.response.data.message.message;
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  //getting order types
  useEffect(() => {
    getOrderTypes();
  }, [page, updater]);

  //calculating page count and handling page change
  const pageCount = Math.ceil(total / 4);
  const handleChange = (_event, value) => {
    setPage(value);
  };

  return (
    <React.Fragment>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {types && (
        <Grid container spacing={2} sx={{ width: "100%", margin: 0 }}>
          {types.map((item) => (
            <Grid key={item.id} item md={3} xs={12}>
              <OrderTypeCarding
                id={item.id}
                name={item.name}
                unitPrice={item.perUnitPrice}
                oneJawPrice={item.jawPrice}
                twoJawPrice={item.twoJawPrice}
              />
            </Grid>
          ))}
        </Grid>
      )}

      {/* Pagination Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          width: "100%",
          marginTop: "20px", // Ensures space below the grid
          clear: "both", // Prevents float issues
        }}
      >
        <Stack>
          <Pagination count={pageCount} onChange={handleChange} />
        </Stack>
      </Box>
    </React.Fragment>
  );
};

export default OrderTypeShow;
